import ErrorReporter from "@bookingcom/error-reporter";
import { isValidClientEventCode, type ClientEventCode } from "../types";

type ClientEventPayload = {
  severity: "error" | "warn";
  code: ClientEventCode;
  message: string;
  stack: string;
  route: string;
  authenticated: boolean;
};

let currentIsAuthenticated = false;

export const setErrorReporterAuth = (isAuth: boolean) => {
  currentIsAuthenticated = isAuth;
};

export const getIsAuthenticated = () => currentIsAuthenticated;

export const errorReporter = new ErrorReporter<ClientEventPayload>({
  endpoint: "/api/v1/frontend-events",
  payloadContentType: "application/json",
  handleWindowErrors: true,
  maxErrorsToReport: 5,
  transform: (e) => ({
    severity: "error",
    code: isValidClientEventCode(e.name) ? e.name : "UNKNOWN",
    message: e.message?.slice(0, 1000) || "",
    stack: e.stack?.slice(0, 4000) || "",
    route: location.pathname.slice(0, 500),
    authenticated: currentIsAuthenticated,
  }),
});
